<template>
  <div style="min-width: 90%">
    <h1 class="grey--text text--darken-2">Контрагенты</h1>

    <div class="mt-3 mb-3">
      <v-btn small :color="selectedItems.length ? 'red' : 'secondary'" :disabled="!selectedItems.length" @click="deleteAction(selectedItems)">
        <v-icon left dark>mdi-delete-circle-outline</v-icon> Удалить
      </v-btn>
      <v-btn small color="blue" dark @click="createAction" class="ml-3">
        <v-icon left dark>mdi-plus-circle-outline</v-icon> Создать
      </v-btn>
      <v-btn small color="yellow" @click="refreshAction" class="ml-3">
        <v-icon left dark>mdi-refresh</v-icon> Обновить
      </v-btn>
    </div>

    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Поиск"
      single-line
      hide-details
      class="mb-3"/>

    <v-data-table
      v-model="selectedItems"
      item-key="companyID"
      :headers="headers"
      :items="items"
      :search="search"
      :loading="loading"
      :page.sync="page"
      disable-sort
      no-data-text="Компании отсутствуют"
      show-select
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, -1],
        showFirstLastPage: true }"
      dense
      @pagination="p"
      class="elevation-1">
      <template v-slot:item.companyName="{ item }">
        <router-link :to="'/companies/'+item.companyID" :class="{ 'editable': true, 'font-weight-medium': item.companyIsDa, 'blue--text': item.companyIsDa }">{{ item.companyLyric ? item.companyLyric : item.companyName }}</router-link>
      </template>
      <template v-slot:item.companyBalance>
        0
      </template>
    </v-data-table>
  </div>
</template>

<script>
import api from '../api'
import { combinedObject } from '@/common.js'

import CompaniesDialog from '@/components/CompaniesDialog.vue'

export default {
  data: () => ({
    loading: false,
    search: '',
    headers: [
      { text: 'Наименование',
        value: 'companyName',
        filter: (value, search, item) => (value.toLowerCase()+' '+item.companyLyric.toLowerCase()).indexOf(search.toLowerCase()) !== -1
      },
      { text: 'Код ЕДРПОУ', value: 'company_edrpou', width: '120px' },
      { text: 'IBAN', value: 'companyIBAN', width: '265px' },
      { text: 'Баланс', value: 'companyBalance', align: 'right', width: '100px' },
    ],
    items: [],
    selectedItems: [],
    page: 1,
    routerPage: 1
  }),
  mounted: function () {
    this.load()
  },
  methods: {
    p (pagination) {
      if ( this.routerPage == pagination.page ) return
      this.$router.push('/companies'+(pagination.page > 1 ? '/page='+pagination.page : ''))
      this.routerPage = pagination.page
    },
    load () {
      this.selectedItems = []
      this.loading = true
      api.get('companies/list').then(response => {
        this.loading = false
        if ( response.data.result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        this.items = combinedObject(response.data.data.cols, response.data.data.rows)
        this.page = this.routerPage = typeof this.$router.currentRoute.params.page === 'undefined' ? 1 : parseInt(this.$router.currentRoute.params.page);
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    },
    refreshAction () {
      this.load()
    },
    createAction () {
      this.$router.push('/companies/new')
    },
    editAction (item) {
      this.$router.push('/companies/'+item.companyID)
    },
    deleteAction (items) {
      if ( !items.length || !confirm('Удалить отмеченные компании ('+items.length+') ?') ) return;
      let del = items.reduce((acc, cur, idx) => (acc[idx] = cur.companyID, acc), [])
      this.loading = true
      api.post('companies/delete', {delete: del}).then(response => {
        this.loading = false
        if ( response.data.result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        this.$root.$alert('Удалено компаний: '+response.data.data.affected)
        this.load()
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    },
  }
}
</script>

<style scoped>
.v-application a { color: inherit; text-decoration: none }
.editable:hover { color: #08A2B8 !important; border-bottom: 1px #08A2B8 dashed; }
</style>
